import { TableRow, TableCell, Stack, Typography, Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useState } from "react";
import { BricksType } from "../../../../../domain/models/brick-management-report/brick-management-data";
import DeactivateBrickModal from "./Modals/DeactivateBrickModal";
import UpdateBrickModal from "./Modals/UpdateBrickModal";
import { CustomerDatabaseStore } from "../../../../../store/main/CustomerDatabaseStore";
import ReasonRemoveModal from "./Modals/ReasonRemoveModal";
import { BrickManagementStore } from "../../../../../store/main/BrickManagementStore";
import UpdateBrickMapViewModal from "./Modals/UpdateBrickMapViewModal";
import WhereToVoteIcon from "@mui/icons-material/WhereToVote";

type Props = {
  row: BricksType;
  hq: string;
  hq_id: number;
  hq_code: string;
};

const BrickTableDetail: React.FC<Props> = ({ row, hq, hq_id, hq_code }) => {
  const { filterStore, userDetails } = CustomerDatabaseStore();
  const { fetchDistrict } = BrickManagementStore();
  const [openUpdateBrick, setOpenUpdateBrick] = useState<boolean>(false);
  const [openRemoveBrick, setOpenRemoveBrick] = useState<boolean>(false);
  const [openReasonRemove, setOpenReasonRemove] = useState<boolean>(false);
  const [openUpdateMapBrick, setOpenUpdateMapBrick] = useState<boolean>(false);

  const successCallbackRemove = () => {
    setOpenRemoveBrick(false);
    setOpenReasonRemove(true);
  };

  const openUpdateBrickModal = () => {
    setOpenUpdateBrick(true);
    fetchDistrict(hq_id);
  };

  const removeBrick = () => {
    setOpenRemoveBrick(true);
    filterStore.brick_ids = [row.brick_id.toString()];
  };

  const openUpdateBrickMapViewModal = () => {
    setOpenUpdateMapBrick(true);
  };

  const openUpdateBrickMapViewModalCallBack = () => {
    setOpenUpdateMapBrick(false);
  };

  return (
    <>
      <TableRow
        sx={{
          bgcolor:
            row.bricks.base_brick === null ||
            row.bricks.description === null 
              ? "error.dark"
              : "",
        }}
      >
        <TableCell>
          <Typography textAlign={"center"} fontSize={12}>
            {hq}
          </Typography>
        </TableCell>
        <TableCell>
          <Typography textAlign={"center"} fontSize={12}>
            {row.brick}
          </Typography>
        </TableCell>
        <TableCell>
          <Typography textAlign={"center"} fontSize={12}>
            {row.bricks.description != null
              ? row.bricks.description.replace(/,/g, "/")
              : "-"}
          </Typography>
        </TableCell>
        <TableCell>
          <Typography textAlign={"center"} fontSize={12}>
            {row.bricks.station != null ? row.bricks.station : "-"}
          </Typography>
        </TableCell>
        <TableCell>
          <Typography textAlign={"center"} fontSize={12}>
            {row.bricks.no_of_work_days != null
              ? row.bricks.no_of_work_days
              : "-"}
          </Typography>
        </TableCell>
        <TableCell>
          <Typography textAlign={"center"} fontSize={12}>
            {row.bricks.expected_business != null
              ? row.bricks.expected_business
              : "-"}
          </Typography>
        </TableCell>
        <TableCell>
          <Typography textAlign={"center"} fontSize={12}>
            {row.bricks.distance_from_hq != null
              ? row.bricks.distance_from_hq
              : "-"}
          </Typography>
        </TableCell>
        <TableCell>
          <Typography textAlign={"center"} fontSize={12}>
            {row.bricks.base_brick ? row.bricks.base_brick.name : "-"}
          </Typography>
        </TableCell>
        <TableCell>
          <Typography textAlign={"center"} fontSize={12}>
            {row.bricks.distance_from_base_brick ?? "-"}
          </Typography>
        </TableCell>
        <TableCell>
          <Stack direction={"row"} justifyContent={"center"}>
            <Button
              disabled={userDetails.button_access === 0}
              onClick={openUpdateBrickModal}
            >
              <EditIcon
                color={userDetails.button_access !== 0 ? "primary" : "disabled"}
              />
            </Button>
            <Button
              disabled={userDetails.button_access === 0}
              onClick={removeBrick}
            >
              <DeleteIcon
                color={userDetails.button_access !== 0 ? "error" : "disabled"}
              />
            </Button>
            <Button
              disabled={userDetails.button_access === 0}
              onClick={openUpdateBrickMapViewModal}
            >
              {row.bricks.description != null ? (
                <WhereToVoteIcon
                  color={
                    userDetails.button_access !== 0 ? "primary" : "disabled"
                  }
                />
              ) : (
                <LocationOnIcon
                  color={userDetails.button_access !== 0 ? "error" : "disabled"}
                />
              )}
            </Button>
          </Stack>
        </TableCell>
      </TableRow>
      {userDetails.button_access !== 0 && openUpdateBrick && (
        <UpdateBrickModal
          open={openUpdateBrick}
          handleClose={() => setOpenUpdateBrick(false)}
          successCallback={() => {}}
          row={row}
          hq={hq}
          brick_id={row.brick_id}
          hq_id={hq_id}
        />
      )}
      {userDetails.button_access !== 0 && openRemoveBrick && (
        <DeactivateBrickModal
          open={openRemoveBrick}
          handleClose={() => setOpenRemoveBrick(false)}
          successCallback={successCallbackRemove}
          row={row}
          hq={hq}
          hq_code={hq_code}
        />
      )}
      {userDetails.button_access !== 0 && openUpdateMapBrick && (
        <UpdateBrickMapViewModal
          open={openUpdateMapBrick}
          handleClose={() => setOpenUpdateMapBrick(false)}
          successCallback={openUpdateBrickMapViewModalCallBack}
          brick={row}
        />
      )}
      {openReasonRemove && (
        <ReasonRemoveModal
          open={openReasonRemove}
          handleClose={() => setOpenReasonRemove(false)}
          id={row.brick_id}
        />
      )}
    </>
  );
};

export default BrickTableDetail;
